import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";

import { Mixpanel } from "../../../../actions/mixpanel.actions";
import * as citiesActions from "../../../../actions/cities.actions";
import * as dropdownsActions from "../../../../actions/dropdowns.actions";
import * as projectActions from "../../../../actions/project.actions";
import * as skillsActions from "../../../../actions/skills.actions";

import ProjectDetail from "../components/ProjectDetail";

const steps = projectId => [
  {
    caption: "Basics",
    url: `/company/project/id/${projectId}/basics`
  },
  {
    caption: "Details",
    url: `/company/project/id/${projectId}/details`
  },
  {
    caption: "Skills",
    url: `/company/project/id/${projectId}/skills`
  },
  {
    caption: "Budget",
    url: `/company/project/id/${projectId}/budget`
  },
  {
    caption: "Review",
    url: `/company/project/id/${projectId}/review`
  }
];

class ProjectDetailContainer extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.projectActions.getProject(this.props.match.params.projectId);
    this.props.dropdownsActions.getWorkTypes();
  }

  handleSubmit(data) {
    const adminEdit = false;
    const loading = true;

    // Track Mixpanel event
    Mixpanel.track("Project Creation - Details - Save + Continue");

    if (data.city && _.isArray(data.city) && data.city.length > 0) {
      localStorage.setItem("projectLocation", JSON.stringify(data.city));
      data.city = data.city[0].description;
    }

    this.props.projectActions.updateProject(
      data,
      "skills",
      this.props.match.params.projectId,
      adminEdit,
      loading
    );
  }

  render() {
    return this.props.project ? (
      <ProjectDetail
        cities={this.props.cities}
        project={this.props.project}
        steps={steps(this.props.match.params.projectId)}
        workTypes={this.props.workTypes}
        onSearchCities={this.props.citiesActions.searchCitiesAutocomplete}
        onSubmit={this.handleSubmit}
      />
    ) : null;
  }
}

const mapStateToProps = state => {
  return {
    cities: state.cities.cities.predictions,
    project: state.project.data.data,
    workTypes: state.dropdowns.workTypes.data,
    isLoading: state.cities.cities.isLoading
  };
};

const mapDispatchToProps = dispatch => ({
  citiesActions: bindActionCreators(citiesActions, dispatch),
  dropdownsActions: bindActionCreators(dropdownsActions, dispatch),
  projectActions: bindActionCreators(projectActions, dispatch),
  skillsActions: bindActionCreators(skillsActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectDetailContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/project/containers/ProjectDetailContainer.js